import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";

/* this file is transformed by vux-loader */

/* eslint-disable */
import _objectSpread from "D:/we-dev/mobile_v2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "D:/we-dev/mobile_v2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "D:/we-dev/mobile_v2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoadMore from 'vux/src/components/load-more';
import Alert from 'vux/src/components/alert';
import Group from 'vux/src/components/group';
import Cell from 'vux/src/components/cell';
import XButton from 'vux/src/components/x-button';
import XInput from 'vux/src/components/x-input';
import XDialog from 'vux/src/components/x-dialog';
import Popup from 'vux/src/components/popup';
import PopupHeader from 'vux/src/components/popup-header';
import PopupPicker from 'vux/src/components/popup-picker';
import Tab from 'vux/src/components/tab/tab';
import TabItem from 'vux/src/components/tab/tab-item';
import InlineXNumber from 'vux/src/components/inline-x-number';
import TransferDom from 'vux/src/directives/transfer-dom';
import moment from 'moment';
import BScroll from 'better-scroll';
import Empty from '@/components/Empty/Empty';
import { Dialog, Toast } from 'vant';
export default {
  name: 'MealOrdering',
  directives: {
    TransferDom: TransferDom
  },
  components: {
    XInput: XInput,
    Group: Group,
    XButton: XButton,
    Cell: Cell,
    Tab: Tab,
    Alert: Alert,
    Popup: Popup,
    PopupHeader: PopupHeader,
    InlineXNumber: InlineXNumber,
    PopupPicker: PopupPicker,
    TabItem: TabItem,
    Empty: Empty,
    LoadMore: LoadMore,
    XDialog: XDialog
  },
  data: function data() {
    return {
      showScrollBox: false,
      //图片显示
      zhanshiPhoto: '',
      //展示照片
      Tebactive: 'a',
      isMsgShow: false,
      //是否显示详情
      mySearch: '',
      weekTitle: ['日', '一', '二', '三', '四', '五', '六'],
      //周标题数组
      weekList: [],
      //周数组
      timestamp: 0,
      //当前时间戳
      year: '',
      userSerial: '',
      month: '',
      currDate: '',
      //选中的某天
      spareCol: '',
      //支付方式
      today: '',
      //今天
      nowTime: '',
      //当前时间
      merchantId: null,
      //商户编号
      placeId: '',
      //场所编号
      mealTypeList: [],
      mealId: '',
      //选择的餐别ID
      curIndex: 0,
      //默认选中的餐别
      goods: [],
      emptyShow: false,
      //数据是否为空
      emptyTip: '暂无菜品',
      listHeight: [],
      //每个菜单将要滑动的height
      scrollY: 0,
      alertFlag: false,
      showCart: false,
      remark: '',
      orderingInfo: [],
      // 多日订餐信息
      meals: [],
      //购物车订餐选择的餐别数组
      mealList: [],
      //购物车订餐选择的菜品数组 数据格式参考 596行
      foodOrder: 0,
      totalNum: 0,
      //预订总份数
      totalPrice: 0,
      //预订总价钱
      rightHeight: '',
      orderDays: [],
      cancelFlag: '',
      foodScroll: null,
      menuScroll: null,
      windowList: [[{
        name: '',
        value: ''
      }]],
      merchantName: null,
      tempMerchantId: [],
      tebList: [],
      //套餐标签
      foodMsgList: [],
      //套餐详情标签
      foodMsgName: '',
      //套餐名字
      limitNum: 0,
      //单餐限制
      dheight: '',
      placeName: '',
      //餐厅名称
      windowName: '',
      //窗口名称
      iftoday: 1,
      //是否开启当日不可预订 0：未开启 1：开启
      spareCol7: 1,
      //是否当天可预定 0：可预订  1：不可预定
      Bookable: 0,
      //是否可预定
      isfirst: 0,
      tie: '',
      xi: 0 //  currentIndex: 0, //当前菜类

    };
  },
  computed: {
    currentIndex: function currentIndex() {
      for (var i = 0; i < this.listHeight.length; i++) {
        var height1 = this.listHeight[i];
        var height2 = this.listHeight[i + 1];

        if (!height2 || this.scrollY >= height1 && this.scrollY < height2) {
          return i;
        }
      }

      return 0;
    }
  },
  watch: {
    showCart: function showCart() {
      document.body.classList;

      if (this.showCart) {
        if (!document.body.classList.contains('modal-open')) {
          document.body.classList.add('modal-open');
        }
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  },
  methods: {
    //添加菜品至购物车的动画效果 foodId
    animation: function animation() {// TODO: 添加到购物车动画
      // let shoppingCart =document.querySelector('#shoppingCart') //  目标对象 终点的坐标
      // let itemCartObj =document.querySelector('#start' + foodId)// 起点对象  获取起点坐标
      // let flyHtml = "<div id='flyItem' class='fly-item'><img src='../../assets/goods.png' alt='' /></img>" // 自定义fly对象
      // let flyer = $(flyHtml)
      // flyer.fly({
      //   start: {
      //     left: itemCartObj.offsetLeft,
      //     top: itemCartObj.offsetTop,
      //   },
      //   end: {
      //     top: shoppingCart.offsetTop,
      //     left: shoppingCart.offsetLeft,
      //     width: 0,
      //     height: 0,
      //   },
      //   onEnd: function () {
      //     flyer.remove() // 结束移除飞行对象
      //   },
      // })
    },
    //跳转共享订单页面
    goShare: function goShare() {
      var _this2 = this;

      this.$api.Meal.getShareList({
        pageIndex: this.curPage,
        pageSize: this.pageNum,
        search: {
          startDate: this.startDate,
          mealState: ['6'],
          endDate: this.endDate
        }
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          _this2.$utils.Tools.toastShow(msg);

          _this2.finished = true;
        } else {
          if (data.records && data.records.length > 0) {
            _this2.$router.push({
              path: '/OrderShare'
            });
          } else {
            Toast('糟糕，还没有人共享订单，请稍后再来哦');
          }
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    },
    // 点击图片
    imChlick: function imChlick(val) {
      if (!val) return;
      this.zhanshiPhoto = val;
      this.showScrollBox = true;
    },
    // 点击套餐详情
    getMsgTxt: function getMsgTxt(id, val, name) {
      if (val) {
        this.isMsgShow = true;
        this.foodMsgList = val;
        this.foodMsgName = name;
      }
    },

    /**
     * @function点击左侧菜类
     *      wzx
     *   2019.05.09
     **/
    selectMenu: function selectMenu(index, event) {
      if (!event._constructed) {
        //避免点击事件发生两次
        return;
      }

      this.xi = index;
      this.xis = true;
      var foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook');
      var el = foodList[index];
      this.foodScroll.scrollToElement(el, 300);
    },
    ha: function ha(index) {
      this.scrollY = this.listHeight[index];
    },

    /**
     * @function获取右侧内容高度
     *      wzx
     *   2019.05.09
     **/
    _calculateHeight: function _calculateHeight() {
      this.scrollY = 0;
      this.listHeight = [];
      var foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook');
      var height = 0;
      this.listHeight.push(height);

      for (var i = 0; i < foodList.length; i++) {
        var item = foodList[i];
        height += item.clientHeight; //元素内容及其边框所占据的空间大小

        this.listHeight.push(height); //将每一个  高度存起来
      }

      this.$refs.foodsul.style.transform = 'translate(0,0) scale(1) translateZ(0px)';
    },

    /**
     * @function设置右侧内容高度
     *      wzx
     *   2019.05.09
     **/
    _initScroll: function _initScroll() {
      var _this3 = this; // 是因为this引用错了，this.scrollY这里的this已经不是全局this了而是这个滑动组件，
      // 所以应该在initScroll这个函数开始的时候把this保存下来：let _this=this，再将之后的this用_this替代


      var _this = this;

      this.menuScroll = new BScroll(this.$refs.menuWrapper, {
        click: true //可以点击

      });
      this.foodScroll = new BScroll(this.$refs.foodsWrapper, {
        probeType: 3,
        //检测滚动的位置
        click: true,
        scrollY: true,
        pullDownRefresh: {
          threshold: 50,
          stop: 0
        },
        pullUpLoad: {
          threshold: 50,
          stop: 0
        }
      });
      setTimeout(function () {
        var height = _this3.listHeight[_this3.listHeight.length - 1]; // 最大需要滚动数

        var clinetHeight = _this3.$refs.foodsWrapper.clientHeight; // 窗口高度

        if (height >= clinetHeight) {
          _this3.foodScroll.maxScrollY = -(height - clinetHeight); // new BScroll 插件初始化值
        }

        _this3.foodScroll.hasVerticalScroll = true; // new BScroll 插件初始化值
        // 获取滚动的Y轴

        _this3.foodScroll.on('scroll', function (pos) {
          _this.scrollY = Math.abs(Math.round(pos.y));

          if (_this.xis) {
            _this.ha(_this.xi);
          }

          _this3.foodScroll.hasVerticalScroll = true; // new BScroll 插件初始化值

          console.log(_this3.foodScroll.hasVerticalScroll, 'this.foodScroll.hasVerticalScroll'); // 获取滚动的Y轴

          _this3.foodScroll.on('scroll', function (pos) {
            _this.scrollY = Math.abs(Math.round(pos.y));

            if (_this.xis) {
              _this.ha(_this.xi);
            }

            _this.xis = false;
          });
        });
      }, 1000);
    },

    /**
     * @function获取当前周数组
     *      wzx
     *   2019.05.05
     **/
    getWeekList: function getWeekList(data) {
      for (var i = 0; i < data.length; i++) {
        this.timestamp = this.$utils.DateUtils.getTimeStamp(data[i]) * 1000;
        this.weekList.push({
          day: this.$utils.DateUtils.formatTimeStamp(this.timestamp),
          week: this.$utils.DateUtils.getWeekTimeStamp(this.timestamp)
        }); //根据周几的时间戳返回周几的日期
      }
    },

    /**
     * @function对象数组排序
     *      wzx
     *   2019.05.06
     **/
    compare: function compare(property) {
      return function (obj1, obj2) {
        var value1 = obj1[property];
        var value2 = obj2[property];
        return value1 - value2; // 升序
      };
    },

    /**
     * @function查看购物车
     *      wzx
     *   2019.05.09
     **/
    cartClick: function cartClick() {
      this.showCart = true;
    },

    /**
     * @function清空购物车
     *      wzx
     *   2019.05.09
     **/
    emptyClick: function emptyClick() {
      this.meals = [];
      this.mealList = [];
      this.totalPrice = 0;
      this.totalNum = 0;
      this.$store.dispatch('actionFoodList', []);
    },
    // 添加餐别 餐别去重
    mealsDuplicateRemoval: function mealsDuplicateRemoval() {
      if (this.mealList && this.mealList.length > 0) {
        var hash = {};
        /*es6数组去重*/

        var foodList = [];
        this.mealList.forEach(function (item) {
          foodList.push.apply(foodList, _toConsumableArray(item.foodList));
        });
        var newArr = foodList.reduceRight(function (item, next) {
          hash[next.mealId] ? '' : hash[next.mealId] = true && item.push(next);
          return item;
        }, []);
        this.meals = newArr.sort(this.compare('mealId'));
      }
    },

    /**
     * @function添加到购物车功能
     *      wzx
     *   2019.05.05
     **/
    addToShopCart: function addToShopCart(event, food) {
      var _this4 = this; //开启当日不可预订功能（iftoday：1）并且该餐别已设置不可当日预定（spareCol7：1）


      if (this.iftoday && this.spareCol7 == 1) return Toast('当前餐别不可当日预订');
      var curDateOrder = (this.mealList || []).find(function (item) {
        return item.date === _this4.currDate;
      });
      var curDateFoodList = curDateOrder ? curDateOrder.foodList : [];
      var mealCount = 0;

      var _iterator = _createForOfIteratorHelper(curDateFoodList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var FItem = _step.value;
          if (FItem.mealId === this.mealId) mealCount += FItem.foodOrder;

          if (mealCount >= this.limitNum && this.limitNum != 0) {
            Toast('已过单餐限制份数');
            return;
          }
        } // if (curDateOrderNum >= this.limitNum && this.limitNum != 0) {
        //   Toast('已过单餐限制份数')
        //   return
        // }

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (food.foodNum - food.foodUse === 0 || food.foodNum - food.foodUse < 0) {
        Toast('此菜份数已预订完！');
        return;
      } //未开启当日不可预定，超时 解决了 预定餐超时再点击别的餐别导致不在提示


      if (this.Bookable == 0) {
        Toast('已过' + food.mealName + '时间，不可预订！');
        return;
      } // TODO: 添加到购物车动画
      // let shoppingCart = $('#shoppingCart').offset() //  目标对象 飞到的终点的坐标
      // let itemCartObj = $('#start' + food.foodId).offset() // 起点对象  获取起点坐标
      // let flyHtml = "<div id='flyItem' class='fly-item'><img src='../../assets/goods.png' alt='' /></img>" // 自定义fly对象
      // let flyer = $(flyHtml)
      // flyer.fly({
      //   start: {
      //     left: itemCartObj.left,
      //     top: itemCartObj.top,
      //   },
      //   end: {
      //     top: shoppingCart.top,
      //     left: shoppingCart.left,
      //     width: 0,
      //     height: 0,
      //   },
      //   onEnd: function () {
      //     flyer.remove() // 结束移除飞行对象
      //   },
      // })


      if (this.mealList.length === 0 || !this.mealList.find(function (item) {
        return item.date === _this4.currDate;
      })) {
        // 区分不同日期, 每个日期是独立的对象
        this.mealList.push({
          date: this.currDate,
          foodList: [_objectSpread(_objectSpread({}, food), {}, {
            foodOrder: 1
          })]
        });
      } else {
        var j; //获取已经添加进购物车的餐品列表

        var list = this.mealList.find(function (item) {
          return item.date === _this4.currDate;
        }).foodList.filter(function (meal, indx) {
          if (meal.foodId === food.foodId && meal.mealId === food.mealId) {
            j = indx;
            return true;
          } else {
            return false;
          }
        });

        if (list.length > 0) {
          this.$set(this.mealList.find(function (item) {
            return item.date === _this4.currDate;
          }).foodList[j], 'foodOrder', this.mealList.find(function (item) {
            return item.date === _this4.currDate;
          }).foodList[j].foodOrder + 1);
        } else {
          this.mealList.find(function (item) {
            return item.date === _this4.currDate;
          }).foodList.push(food);
          this.$set(this.mealList.find(function (item) {
            return item.date === _this4.currDate;
          }).foodList[this.mealList.find(function (item) {
            return item.date === _this4.currDate;
          }).foodList.length - 1], 'foodOrder', 1);
        }
      } //设置餐别


      this.mealsDuplicateRemoval(); // this.totalPrice = 0
      // this.totalNum = 0
      //设置已选餐品份数及总金额

      var totalPrice = 0;
      this.totalNum = 0;

      var _iterator2 = _createForOfIteratorHelper(this.mealList),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;

          var _iterator3 = _createForOfIteratorHelper(item.foodList),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var foodItem = _step3.value;
              totalPrice += parseFloat((foodItem.foodPrice * foodItem.foodOrder).toFixed(2));
              this.totalNum += foodItem.foodOrder;
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.totalPrice = Math.round(totalPrice * 100) / 100;
    },

    /**
     * @function订单份数变化
     *      wzx
     *   2019.05.09
     **/
    changeNum: function changeNum(val, idx, food, mealIndex) {
      if (food.foodOrder <= food.foodNum - food.foodUse) {
        this.totalPrice = 0;
        this.totalNum = 0;

        if (val === 0) {
          //如果该日期只有一项餐品 则直接删除该日期 否则删除当前餐品项
          if (this.mealList[mealIndex].foodList.length === 1) {
            this.mealList.splice(mealIndex, 1);
          } else {
            this.mealList[mealIndex].foodList.splice(idx, 1);
          }

          this.mealsDuplicateRemoval();
        } //设置已选餐品份数及总金额


        var totalPrice = 0;
        this.totalNum = 0;

        var _iterator4 = _createForOfIteratorHelper(this.mealList),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var item = _step4.value;

            var _iterator5 = _createForOfIteratorHelper(item.foodList),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var foodItem = _step5.value;
                totalPrice += parseFloat((foodItem.foodPrice * foodItem.foodOrder).toFixed(2));
                this.totalNum += foodItem.foodOrder;
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.totalPrice = Math.round(totalPrice * 100) / 100;
      } else {
        Toast('此菜份数已预订完！');
      }
    },

    /**
     * @function获取当前日期
     *      wzx
     *   2019.04.12
     **/
    getSysDate: function getSysDate() {
      var _this5 = this;

      this.$utils.Tools.loadShow();
      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        _this5.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this5.$code.success) {
          Toast(msg);
        } else {
          _this5.today = data.sysDate.substring(0, 10); // this.year = data.sysDate.substring(0, 4)
          // this.month = data.sysDate.substring(5, 7)

          _this5.nowTime = data.sysDate.substring(11, 16);

          _this5.getMealDays(_this5.placeId);
        }
      }).catch(function () {
        _this5.$utils.Tools.httpError();
      });
    },

    /**
     * @function获取当前日期下的菜品列表
     *      wzx
     *   2019.05.05
     **/
    dayClick: function dayClick(day) {
      this.month = moment(day.day).format('MM');
      this.iftoday = this.$utils.DateUtils.twoTimeInterval(this.today, day.day) >= 24 ? 0 : 1;

      if (this.orderDays.indexOf(day.day) > -1) {
        if (this.cancelFlag === '0' && this.currDate !== day.day) {
          Toast('现场订餐只可选择当天！');
        } else {
          // 清空购物车
          // this.emptyClick()
          // 清空当前餐别菜品
          // this.emptyMeals()
          this._initScroll();

          this.currDate = day.day;
          this.getMealTypeList(this.currDate, this.merchantId, this.placeId);
        }
      } else {
        Toast('预订时间外不可预订！');
      }
    },

    /**
     * @function获取搜索的菜品列表
     *      wzx
     *   2019.05.05
     **/
    goSearch: function goSearch() {
      this.getFoodList(this.currDate, this.mySearch, this.mealId, this.merchantId, this.placeId);
    },

    /**
     * @function清空搜索内容后获取当前的菜品列表
     *      wzx
     *   2019.05.05
     **/
    clearSearch: function clearSearch() {
      this.mySearch = '';
      this.$refs.searchInput.blur();
      this.goSearch();
    },

    /**
     * @function获取当前日期选择的餐别
     *      wzx
     *   2019.05.05
     **/
    onItemClick: function onItemClick(id, index, name, spareCol7, Bookable) {
      this.mealName = name; //  this.placeName = name

      this.foodScroll.refresh();
      this.menuScroll.refresh();
      this.mealId = id;

      this._initScroll();

      this.curIndex = index;
      this.spareCol7 = spareCol7;
      this.Bookable = Bookable;
      this.listHeight = []; //每个菜单将要滑动的height

      this.scrollY = 0;
      this.getFoodList(this.currDate, this.mySearch, this.mealId, this.merchantId, this.placeId, this.Bookable);
    },
    getMealDays: function getMealDays(placeId) {
      var _this6 = this;

      this.$api.Meal.selectDayState({
        placeId: placeId,
        userSerial: this.userSerial
      }).then(function (response) {
        _this6.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this6.$code.success) {
          Toast(msg);
        } else {
          // data.splice(0,1)//lwt  ---修改  -- 当天不可以预定2020-06-30  --企业不需要这个
          _this6.orderDays = data;
          _this6.iftoday = _this6.$utils.DateUtils.twoTimeInterval(_this6.today, data[0]) >= 24 ? 0 : 1;

          if (data.length > 0) {
            _this6.currDate = data[0];

            _this6.getWindowsList();

            _this6.year = data[0].substring(0, 4);
            _this6.month = data[0].substring(5, 7);

            _this6.getWeekList(data);
          }
        }
      }).catch(function () {
        _this6.$utils.Tools.httpError();
      });
    },
    currentDate: function currentDate() {
      var d = new Date();
      var y = d.getFullYear(); // 年

      var m = d.getMonth() + 1; // 月份从0开始的

      var yesterday_d = d.getDate() - 1; //日

      var today_d = d.getDate(); //日

      var tomorrow_d = d.getDate() + 1; //日

      if (m < 10) {
        m = '0' + m;
      }

      if (yesterday_d < 10) {
        yesterday_d = '0' + yesterday_d;
      }

      if (today_d < 10) {
        today_d = '0' + today_d;
      }

      if (tomorrow_d < 10) {
        tomorrow_d = '0' + tomorrow_d;
      }

      var yesterday = y + '-' + m + '-' + yesterday_d;
      var today = y + '-' + m + '-' + today_d;
      var tomorrow = y + '-' + m + '-' + tomorrow_d;
      var dateList = [yesterday, today, tomorrow];
      return dateList;
    },

    /**
     * @function获取当前日期的餐别数组
     *      wzx
     *   2019.05.05
     **/
    getMealTypeList: function getMealTypeList(date, merchantId, placeId) {
      var _this7 = this;

      this.$utils.Tools.loadShow();
      this.listHeight = [];
      this.$api.Meal.getMealTypeList({
        date: date,
        placeId: placeId,
        userSerial: this.userSerial
      }).then(function (response) {
        _this7.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this7.$code.success) {
          Toast(msg);
        } else {
          _this7.mealTypeList = data;
          _this7.mealId = data[0].mealId;
          _this7.limitNum = data[0].spareCol5;
          _this7.spareCol7 = data[0].spareCol7;

          var DateList = _this7.currentDate();

          var today = DateList[1];
          var tomorrow = DateList[2];

          for (var i = 0; i < data.length; i++) {
            // 判断是否当日不可预订（spareCol7=1表示当日不可预定）
            if (data[i].spareCol7 == 1) {
              //判断当前时间是否超过可预订截止时间
              //  超过：当日不可定，第二天也不可定，第三天可定
              if (_this7.nowTime > data[i].orderEnd) {
                // 选择日期为当日(当日超时，不可定)
                if (_this7.currDate == today) {
                  data[i].Bookable = 0;

                  if (_this7.isfirst == 0) {
                    _this7.Bookable = 0;
                  }

                  _this7.curIndex = 0;
                } //  选择日期为明天(明天不可预定)


                if (_this7.currDate == tomorrow) {
                  if (_this7.isfirst == 0) {
                    _this7.Bookable = 0;
                  }

                  data[i].Bookable = 0;
                  _this7.curIndex = 0;
                } //第三天可以预定


                if (_this7.currDate != today && _this7.currDate != tomorrow) {
                  _this7.Bookable = 1;
                  data[i].Bookable = 1;
                  _this7.curIndex = 0;
                  _this7.mealId = data[0].mealId;
                  _this7.spareCol = data[0].spareCol1;
                  break;
                }
              } else if (_this7.nowTime < data[i].orderEnd) {
                //未超时：当日不可定，明天可定
                if (_this7.currDate == today) {
                  if (_this7.isfirst == 0) {
                    _this7.Bookable = 0;
                  }

                  data[i].Bookable = 0;
                  _this7.curIndex = 0;
                } //  选择日期为明天(明天可预定)


                if (_this7.currDate == tomorrow) {
                  _this7.Bookable = 1;
                  data[i].Bookable = 1;
                  _this7.curIndex = i;
                  _this7.mealId = data[i].mealId;
                  _this7.spareCol = data[i].spareCol1;
                  break;
                } // 景  第三天可预订为


                if (_this7.currDate != today && _this7.currDate != tomorrow) {
                  _this7.Bookable = 1;
                  data[i].Bookable = 1;
                  _this7.curIndex = 0;
                  _this7.mealId = data[0].mealId;
                  _this7.spareCol = data[0].spareCol1;
                  break;
                }
              }
            } else if (data[i].spareCol7 == 0) {
              //未开启当日不可定，则走正常判断时间流程
              // operate：是否允许订餐  0 不允许 1 允许
              //判断之前是否已有可预定餐别 0：没有 1：有
              _this7.Bookable = data[i].operate;
              data[i].Bookable = data[i].operate;

              if (_this7.Bookable == 1) {
                _this7.isfirst = 1;
                _this7.curIndex = i;
                _this7.mealId = data[i].mealId;
                _this7.spareCol = data[i].spareCol1; // 景  只要是其他日期的餐别都是可以订的

                break;
              }
            }
          }

          _this7.getFoodList(_this7.currDate, _this7.mySearch, _this7.mealId, _this7.merchantId, _this7.placeId);
        }
      }).catch(function () {
        _this7.$utils.Tools.httpError();
      });
    },

    /**
     * @function获取当前日期下的菜品清单
     *      wzx
     *   2019.05.05
     **/
    getFoodList: function getFoodList(date, foodName, mealId, merchantId, placeId) {
      var _this8 = this;

      this.goods = [];
      this.xi = 0;
      this.xis = false;
      this.$utils.Tools.loadShow();
      this.$api.Meal.getFoodList({
        date: date,
        foodName: foodName,
        mealId: mealId,
        merchantId: merchantId,
        placeId: placeId
      }).then(function (response) {
        _this8.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this8.$code.success) {
          _this8.$utils.Tools.toastShow(msg);
        } else {
          _this8.goods = [];

          if (data.menuList.length > 0 && data.typeList.length > 0) {
            _this8.emptyShow = false;
            var jh = '';

            var _iterator6 = _createForOfIteratorHelper(data.typeList),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var type = _step6.value; // 将餐盒放在最下边

                if (type.typeName == '餐盒') {
                  jh = {
                    typeCode: type.typeCode,
                    typeName: type.typeName,
                    meals: []
                  };
                } else {
                  _this8.goods.push({
                    typeCode: type.typeCode,
                    typeName: type.typeName,
                    meals: []
                  });
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }

            if (jh != '') {
              _this8.goods.push(jh);
            }

            if (_this8.goods.length > 0) {
              var _iterator7 = _createForOfIteratorHelper(_this8.goods),
                  _step7;

              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var item = _step7.value;

                  var _iterator9 = _createForOfIteratorHelper(data.menuList),
                      _step9;

                  try {
                    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                      var food = _step9.value;

                      if (food.foodType === item.typeCode) {
                        item.meals.push({
                          foodId: food.foodId,
                          foodName: food.foodName,
                          foodNum: food.foodNum,
                          foodUse: food.foodUse,
                          foodPhoto: food.foodPhoto,
                          foodPrice: food.foodPrice,
                          foodType: food.foodType,
                          mealId: food.mealId,
                          mealName: food.mealName,
                          merchantId: food.merchantId,
                          operate: food.operate,
                          orderEnd: food.orderEnd,
                          placeId: food.placeId,
                          // spareCol1:fond.spareCol1
                          spareCol1: food.spareCol1,
                          spareCol2: food.spareCol2,
                          spareCol3: food.spareCol3
                        });
                      }
                    }
                  } catch (err) {
                    _iterator9.e(err);
                  } finally {
                    _iterator9.f();
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }

              _this8.goods.forEach(function (items) {
                items.meals.forEach(function (mealsItems) {
                  if (mealsItems.spareCol2) {
                    mealsItems.spareCol2 = mealsItems.spareCol2.split(',');
                  }

                  if (mealsItems.spareCol3) {
                    mealsItems.spareCol3 = mealsItems.spareCol3.split(',');
                  }
                });
              });

              _this8.mealList = _this8.$store.getters.getterFoodList;
              var totalPrice = 0;
              _this8.totalNum = 0;
              _this8.meals = [];

              var _iterator8 = _createForOfIteratorHelper(_this8.mealList),
                  _step8;

              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var _item = _step8.value;

                  var _iterator10 = _createForOfIteratorHelper(_item.foodList),
                      _step10;

                  try {
                    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                      var _food = _step10.value; // for (let temp of data.menuList) {
                      //   if (temp.mealId === food.mealId && temp.foodId === food.foodId) {
                      //     food.foodOrder = Math.min(food.foodOrder, temp.foodNum - temp.foodUse)
                      //     break
                      //   }
                      // }
                      //设置已选餐品份数及总金额

                      totalPrice += parseFloat((_food.foodPrice * _food.foodOrder).toFixed(2));
                      _this8.totalNum += _food.foodOrder;
                    }
                  } catch (err) {
                    _iterator10.e(err);
                  } finally {
                    _iterator10.f();
                  }
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }

              _this8.totalPrice = Math.round(totalPrice * 100) / 100; //餐别去重

              _this8.mealsDuplicateRemoval();

              _this8.$nextTick(function () {
                _this8._calculateHeight();
              });
            }
          } else {
            _this8.emptyShow = true;
          }
        }
      }).catch(function () {
        _this8.$utils.Tools.httpError();
      });
    },

    /**
     * @function获取订餐说明弹窗
     *      wzx
     *   2019.05.05
     **/
    showExplain: function showExplain() {
      var _this9 = this; // this.alertFlag = true;


      this.$utils.Tools.loadShow();
      this.$api.Meal.getExplain(this.placeId).then(function (response) {
        _this9.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this9.$code.success) {
          Toast(msg);
        } else {
          if (data == null || data == '') {
            Toast('暂无相关说明');
          }

          _this9.remark = data;
          _this9.img = data.spareCol2;
          var img = "<img style='width:100%'  src=".concat(data.spareCol2, ">");
          var Dsrc;

          if (data.spareCol2) {
            Dsrc = data.dineShow + '\n \n \n' + img;
          } else {
            Dsrc = data.dineShow + '\n \n \n';
          }

          Dialog.alert({
            title: '订餐说明',
            message: Dsrc,
            messageAlign: 'left'
          }).then(function () {// on close
          });
        }
      }).catch(function () {
        _this9.$utils.Tools.httpError();
      });
    },

    /**
     * @function点击去结算
     *      wzx
     *   2019.05.09
     **/
    goPay: function goPay() {
      // let mealList = JSON.stringify(this.mealList);
      this.$store.dispatch('actionFoodList', this.mealList);
      this.$router.push({
        path: '/OrderPay',
        query: {
          orderDate: this.currDate,
          placeId: this.placeId,
          cancelFlag: this.cancelFlag,
          spareCol: this.spareCol,
          placeName: this.placeName,
          windowName: this.windowName
        }
      });
    },

    /**
     * @function查看订单记录
     *      wzx
     *   2019.05.09
     **/
    historyClick: function historyClick() {
      this.$router.push('/OrderRecord');
    },
    //获取该餐厅的窗口列表
    getWindowsList: function getWindowsList() {
      var _this10 = this;

      this.$api.AcDep.selectListByEntity({
        depDefine: 1,
        depParent: this.placeId
      }).then(function (response) {
        _this10.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this10.$code.success) {
          Toast(msg);
        } else {
          if (data && data.length > 0) {
            _this10.windowList = [[]];

            for (var i = 0; i < data.length; i++) {
              if (i === 0) {
                _this10.merchantId = data[0].depSerial;
                _this10.merchantName = data[0].depName;
                _this10.windowName = data[0].depName;
                _this10.tempMerchantId = [data[0].depSerial + ''];
              }

              _this10.windowList[0].push({
                name: data[i].depName,
                value: data[i].depSerial + ''
              });
            }
          }
        }
      }).catch(function () {
        _this10.$utils.Tools.httpError();
      });
    },
    // 改变订餐窗口
    windowChange: function windowChange(value) {
      var windowLists = this.windowList[0];

      for (var i = 0; i < windowLists.length; i++) {
        if (windowLists[i].value == value[0]) {
          this.windowName = windowLists[i].name;
        }
      }

      this.emptyClick();
      this.merchantId = value[0];
      this.getMealTypeList(this.currDate, this.merchantId, this.placeId);
    },
    // 校验日期是否展示
    handleDateShow: function handleDateShow(mealItem, meal, itemIndex) {
      var foodMeals = mealItem.foodList.map(function (item) {
        return item.mealId;
      });

      for (var i = 0; i <= itemIndex; i++) {
        if (foodMeals.includes(this.meals[i].mealId)) {
          return mealItem.foodList.length > 0 && mealItem.foodList.some(function (foodMealItem) {
            return foodMealItem.mealId === meal.mealId;
          }) && itemIndex === i;
        }
      }

      return false;
    }
  },
  created: function created() {
    this.placeId = this.$route.query.placeId;
    this.cancelFlag = this.$route.query.cancelFlag;
    this.placeName = this.$route.query.placeName;
    this.userSerial = this.$utils.Store.getItem('userSerial');
    this.getSysDate();
  },
  mounted: function mounted() {
    var _this11 = this;

    this.dheight = document.body.clientHeight;
    this.$nextTick(function () {
      document.querySelector('.meal-ordering').style.height = _this11.dheight + 'px';

      _this11._initScroll(); //页面渲染完毕，初始化better-scroll组件

    });
  },
  updated: function updated() {
    var foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook');

    if (foodList[foodList.length - 1]) {
      var foodHeight = foodList[foodList.length - 1].clientHeight;
      var outerHeight = this.$refs.foodsWrapper.clientHeight;

      if (foodHeight < outerHeight) {
        foodList[foodList.length - 1].style.height = outerHeight + 'px';
      }
    }
  }
};